import styled from 'styled-components'

export const TitleApp = styled.h1`
    padding-bottom: 20px; 
`